import { gql } from '@apollo/client';

export const CREATE_EVENT = gql`
  mutation($record: EventCreateInput!) {
    schedule {
      createEvent(record: $record) {
        ok
        error {
          code
          message
        }
        result {
          id
          title
          eventType
          startDate
          endDate
          createdAt
          patients {
            id
            status
            firstName
            lastName
          }
          users {
            id
            firstName
            lastName
            status
          }
        }
      }
    }
  }
`;
